import {Component, Input, OnInit} from '@angular/core';
import {FoEventsService} from "../foevents.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-pricing-statut',
  templateUrl: './pricing-statut.component.html',
  styleUrls: ['./pricing-statut.component.css']
})
export class PricingStatutComponent implements OnInit {
  @Input() pricing: any;

  constructor() { }

  ngOnInit() {

  }


  isCominglabel(pricing) {
    return (pricing.Totalplace >= 0 || pricing.Totalplace == -1) && pricing.IsComing && !pricing.IsClosed
  }


  isExhausted(pricing) {
    return (pricing.Totalplace <= 0 && pricing.Totalplace != -1) && !pricing.IsComing && !pricing.IsClosed
  }


  isClosedlabel(pricing) {
    return ((pricing.Totalplace >= 0 || pricing.Totalplace == -1) ) && !pricing.IsComing && pricing.IsClosed
  }

}
